module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/072-bonaire-12afb8401d2275b3afa96afebc0dbe2a.svg";